import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditMenuVisibilityPayload {
    settingId: string
    data: any
}

export interface IEditMenuVisibilityState {
    status: string
    data: any
    errors: any
}

const initialState: IEditMenuVisibilityState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editMenuVisibility = createSlice({
    name: 'event-setting/edit-menu-visibility',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditMenuVisibilityPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editMenuVisibilityActions = editMenuVisibility.actions
export default editMenuVisibility.reducer
